<template>
  <component
    v-if="visible"
    :is="container"
    class="magic-ui-overlay"
    :config="{ items: config.items }"
  >
    <slot></slot>
  </component>
</template>
<script lang="ts" setup>
import { reactive } from 'vue';
import type { MComponent } from '@tmagic/schema';

import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay'
import getDependenceComponentKey from '../../../utils/getDependenceComponent';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
}>();

const container = getDependenceComponentKey(initValue.dependencies, 'container');
useApp(props);
const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  show,
  hide,
});
defineExpose(exportInterface);
</script>
